$("#gotocenter").on("keyup", function (e) {
  e.preventDefault();
  let center_href = $(this).attr("href");
  if (e.keyCode === 13) {
    $(".accesskey").each(function () {
      let href = $(this).attr("href");
      if (href === center_href) {
        $(this).focus();
      }
    });
  }
});
$(".select_block").click((e) => e.stopPropagation());

$(".select_block > .title_block").click(function () {
  let dropdown = $(this).next(".select_dropbox");
  let disable = $(this).hasClass("disabled");
  let prev = $(this).hasClass("open");
  $(".select_block > .title_block").removeClass("open");
  $(".select_block > .select_dropbox").slideUp();
  if (!disable) {
    if (prev) {
      $(this).removeClass("open");
      this.setAttribute("aria-expanded", "false");
      dropdown.slideUp();
    } else {
      $(this).addClass("open");
      this.setAttribute("aria-expanded", "true");
      dropdown.slideDown();
    }
  }
}); //  select 下拉選單
$("body").click((e) => {
  $(".select_block > .select_dropbox").slideUp(200);
  $(".select_block > .title_block").removeClass("open");
  $(".select_down").removeClass("open");
  $(".option_block").slideUp();
  $(".calendar").slideUp();
});

$(".select_block > .select_dropbox ").delegate("li", "click", function (e) {
  let type = $(this).parent(".select_dropbox").data("type");

  if (type == "PenaltyAgencyList") {
    type = "County";
  }

  let value = $(this).data("value"); //欄位排序
  //依地點查詢：距離選項
  let filter_distance = $(this).parent(".select_dropbox").hasClass("filter_distance");
  let disable = $(this).hasClass("disabled");
  let this_distance = $(this).data("distance");
  let new_url = new URL(location.href);

  if (filter_distance) {
    new_url.searchParams.set("distance", this_distance);
    if (urlParams.get("map")) {
      new_url.searchParams.set("map", $(".map_btn").hasClass("map_show") ? 1 : 0);
    } else {
      new_url.href = `${new_url}&map=${$(".map_btn").hasClass("map_show") ? 1 : 0}`;
    }
    localStorage.setItem("selected_items", JSON.stringify([]));
    window.location.href = new_url.href;
  }
  if (!disable) {
    if (type) {
      if (value) {
      } else {
        value = $(this).children("button").text().trim();
        if (value == "全部") {
          value = "";
        }
      }
      if (mobileMediaQuery.matches) {
        if (type === "PenaltyAgencyList") {
          mobile_fetchData.PenaltyAgencyList = value;
          mobile_fetchData.County = value;
        } else {
          mobile_fetchData[type] = value;
        }
      } else {
        if (urlParams.get(type) || urlParams.get(type) === "") {
          // console.log(`${type}:${urlParams.get(type)}`)

          new_url.searchParams.set(type, value);
        } else {
          new_url.href = `${new_url}&${type}=${value}`;
        }
        window.location.href = new_url.href;
      }
    }
    $(this).parent(".select_dropbox").parent(".select_block").find("li").removeClass("selected");
    $(".select_block > .title_block").removeClass("open");
    $(this).addClass("selected");
    selected_check();
  }

  $(this).parent(".select_dropbox").slideUp();
});

function selected_check(text) {
  $(".select_block > .select_dropbox li").each(function () {
    let filter_distance = $(this).parent(".select_dropbox").hasClass("filter_distance");
    let type = $(this).parent(".select_dropbox").data("type");
    if (type) {
      //列管事業欄位排序
      if (type === "FactOrder") {
        if (filter_obj) {
          let value = $(this).data("value");
          if (value === filter_obj[type]) {
            $(this).addClass("selected");
          }
        }
      }
    }
    let selected = $(this).hasClass("selected");
    if (selected) {
      if (!filter_distance) {
        text = $(this).children("button").text();
      }
      $(this).parent(".select_dropbox").prev(".title_block").children(".title").text(text);
    }
    if (filter_distance) {
      if (text) {
        if (text == $(this).children("button").text()) {
          $(this).addClass("selected");
        } else {
          $(this).removeClass("selected");
        }
      }
    }
  });
}

//header 行動版 「menu」
$(".menu_hamburger").click(function (e) {
  const button = e.currentTarget;
  let responsive_menu = $(".responsive_menu");
  if (responsive_menu.hasClass("open")) {
    $(responsive_menu).removeClass("open");
    button.setAttribute("aria-expanded", "false");
    // $("body").css("overflow", "unset");
    $("body")[0].classList.remove("overflow-hidden");
    responsive_menu.slideUp();
    dropdown.slideUp();
  } else {
    $(responsive_menu).addClass("open");
    button.setAttribute("aria-expanded", "true");
    // $("body").css("overflow", "hidden");
    $("body")[0].classList.add("overflow-hidden");
    responsive_menu.slideDown();
    createFocusTrap($(".responsive_menu")[0], $(".menu_hamburger")[0], () => {
      $(".menu_close")[0].click();
    });
    $(".menu_close")[0].focus();
  }
});
$(".menu_close").click(function () {
  let responsive_menu = $(".responsive_menu");
  $(responsive_menu).removeClass("open");
  $(".menu_hamburger")[0].setAttribute("aria-expanded", "false");
  // $("body").css("overflow", "unset");
  $("body")[0].classList.remove("overflow-hidden");
  responsive_menu.slideUp();
  $(".menu_hamburger")[0].focus();
});

//行動版 - 篩選條件選單
$(".filter_block_mobile").click(function () {
  $(".filter_slide_down_block").slideDown();
  $("body").css("overflow", "hidden");
});
//行動版 - 排序選單
$(".sort_block_mobile").click(function () {
  let type = $(this).data("type");
  let disabled = $(this).parent("div").hasClass("disabled");
  if (!disabled) {
    if (type) {
      $(`.${type}`).slideDown();
    } else {
      $(".sort_slide_down_block").slideDown();
    }
    $("body").css("overflow", "hidden");
  }
});

$(".slide_down_block > .block_header > .close").click(function () {
  $(".slide_down_block").slideUp();
  $("body").css("overflow", "unset");
});
$(".modal_inner > .modal_header > .close").click(function () {
  $(".modal_block").fadeOut();
  $("body").css("overflow", "unset");
});
//資料說明
$(".dropdown_btn").click(function (e) {
  const button = e.currentTarget;
  let title_block = $(this).parent(".title_block");
  if (title_block.hasClass("open")) {
    $(title_block).removeClass("open");
    button.setAttribute("aria-expanded", "false");
    title_block.siblings(".content_block").slideUp();
  } else {
    $(title_block).addClass("open");
    button.setAttribute("aria-expanded", "true");
    title_block.siblings(".content_block").slideDown();
  }
});
$(document).scroll(function () {
  let top = $(document).scrollTop();
  if (top > 100) {
    $(".top_btn").fadeIn(100);
    $(".top_btn").css("display", "flex");
    $(".webchat_btn").attr("class", "webchat_btn");
  } else {
    $(".top_btn").fadeOut(100);
    $(".top_btn").css("display", "none");
    $(".webchat_btn").attr("class", "webchat_btn top");
  }
});
$(".top_btn").click(function () {
  $(document).scrollTop(0);
});

function svg_to_xml() {
  jQuery("img.svg").each(function () {
    let $img = jQuery(this);
    let imgID = $img.attr("id");
    let imgClass = $img.attr("class");
    let imgURL = $img.attr("src");
    let imgAlt = $img.attr("alt");

    jQuery.get(
      imgURL,
      function (data) {
        // Use DOMParser to parse the SVG content
        var parser = new DOMParser();
        var xmlDoc = parser.parseFromString(data, "image/svg+xml");

        // Get the SVG tag from the parsed document
        var $svg = jQuery(xmlDoc).find("svg");

        // Add replaced image's ID to the new SVG
        if (typeof imgID !== "undefined") {
          $svg.attr("id", imgID);
        }

        // Add replaced image's classes to the new SVG
        if (typeof imgClass !== "undefined") {
          $svg.attr("class", imgClass + " replaced-svg");
        }

        // Remove any invalid XML tags as per http://validator.w3.org
        $svg.removeAttr("xmlns:a");

        // Check if the viewport is set, if not, set it to ensure SVG scales correctly
        if (!$svg.attr("viewBox") && $svg.attr("height") && $svg.attr("width")) {
          $svg.attr("viewBox", "0 0 " + $svg.attr("height") + " " + $svg.attr("width"));
        }

        // Replace image with new SVG
        $img.replaceWith($svg);
      },
      "html" // Change the datatype to "html" to let jQuery handle parsing as HTML
    );
  });
}

// Get element by id
function getId(id) {
  return document.getElementById(id);
}
$(document).ready(function () {
  svg_to_xml();
  selected_check();
  function setCookie(c_name, value, exdays) {
    let now = moment().format("YYYY-MM-DD :00:00");
    let exdate = new Date(now);
    exdate.setDate(exdate.getDate() + exdays);
    let c_value = escape(value) + (exdays == null ? "" : "; expires=" + exdate.toUTCString());
    document.cookie = c_name + "=" + c_value;
  }

  function getCookie(c_name) {
    let c_value = document.cookie;
    let c_start = c_value.indexOf(" " + c_name + "=");
    if (c_start == -1) {
      c_start = c_value.indexOf(c_name + "=");
    }
    if (c_start == -1) {
      c_value = null;
    } else {
      c_start = c_value.indexOf("=", c_start) + 1;
      let c_end = c_value.indexOf(";", c_start);
      if (c_end == -1) {
        c_end = c_value.length;
      }
      c_value = unescape(c_value.substring(c_start, c_end));
    }
    return c_value;
  }

  checkSession();

  function checkSession() {
    let c = getCookie("visited");
    if (c === "yes") {
      // alert("Welcome back!");
    } else {
      setCookie("visited", "yes", 1);

      $.ajax({
        url: `${host}api/v1/Web/AddVisit`,
        type: "POST",
        headers: {
          Accept: "application/json",
        },
        success: function (data) {
          console.log(data);
        },
      });
    }
  }
});

function customCalendar(start, end, table_index, selectedValue) {
  let current_date = "";
  let ranged_obj = [];
  if (start && end) {
    if (start !== "" && end !== "") {
      let a = moment(start);
      let b = moment(end);
      let examined_second_click = b.diff(a, "days");
      for (let d = 0; d < examined_second_click - 1; d++) {
        let this_day = moment(start)
          .add(d + 1, "d")
          .format("YYYY-MM-DD");
        ranged_obj.push(this_day);
      }
    }
  }
  if (selectedValue) {
    current_date = selectedValue;
  } else {
    current_date = moment().format("YYYY-MM-DD");
  }
  // if (start !== "" && end === "") {
  //     current_date = start;
  // } else if (!start && !end) {
  //     //若無時間區間
  // } else {
  //     current_date = end;
  // }

  // let reform_date = table_index === 0 ? moment(current_date).add(1, "month").format("YYYY-MM-DD") : current_date;
  // // if (mobileMediaQuery.matches) {
  // reform_date = current_date;
  // // }
  let Cal = function (divId) {
    //Store div id
    this.divId = divId;
    // Days of week, starting on Sunday
    this.DaysOfWeek = ["日", "一", "二", "三", "四", "五", "六"];

    // Months, stating on January
    this.Months = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    // Set the current month, year
    let d = new Date(current_date);
    this.currMonth = d.getMonth();
    this.currYear = d.getFullYear();
    this.currDay = d.getDate();
    this.today = moment().format("D");
    // this.month_arr = mobileMediaQuery.matches ? [d.getMonth()] : [d.getMonth() - 1, d.getMonth()];
    this.month_arr = [d.getMonth()];
  };
  // Goes to next month
  Cal.prototype.nextMonth = function () {
    if (this.currMonth == 11) {
      this.currMonth = 0;
      this.currYear = this.currYear + 1;
    } else {
      this.currMonth = this.currMonth + 1;
    }
    this.month_arr = mobileMediaQuery.matches ? [this.currMonth] : [this.currMonth - 1, this.currMonth];
    this.showcurr();
  };

  // Goes to previous month
  Cal.prototype.previousMonth = function () {
    if (this.currMonth == 0) {
      this.currMonth = 11;
      this.currYear = this.currYear - 1;
    } else {
      this.currMonth = this.currMonth - 1;
    }
    this.month_arr = [this.currMonth];
    this.showcurr();
  };
  // Goes to next month
  Cal.prototype.nextMonth = function () {
    if (this.currMonth == 11) {
      this.currMonth = 1;
      this.currYear = this.currYear + 1;
    } else {
      this.currMonth = this.currMonth + 1;
    }
    this.month_arr = [this.currMonth];
    this.showcurr();
  };
  // Show current month
  Cal.prototype.showcurr = function () {
    $(this.divId).empty();
    let m = this.month_arr[0];
    this.showMonth(m === -1 ? this.currYear - 1 : this.currYear, m === -1 ? 11 : m, 0);
    // this.month_arr.forEach((m, i) => this.showMonth(m === -1 ? this.currYear - 1 : this.currYear, m === -1 ? 11 : m, i))
  };

  // Show month (year, month)
  Cal.prototype.showMonth = function (y, m, month_index) {
    let d = new Date(current_date),
      // First day of the week in the selected month
      firstDayOfMonth = new Date(y, m, 1).getDay(),
      // Last day of the selected month
      lastDateOfMonth = new Date(y, m + 1, 0).getDate(),
      // Last day of the previous month
      lastDayOfLastMonth = m == -1 ? new Date(y - 1, 11, 0).getDate() : new Date(y, m, 0).getDate();
    let chk = new Date();
    let chkY = chk.getFullYear();
    let chkM = chk.getMonth();
    let html = `<table data-index=${month_index}>`;
    // console.log(m)

    // Write selected month and year
    html += "<thead><tr>";
    if (month_index === 0) {
      html += `
            <th scope="col" colspan="7">
                <div>
                    <button class="btnPrev" aria-label="prev">
                        <img src="img/icon/chevron-left.svg" class="svg"> </button>
                    <div class="title left header_title">
                        <button aria-label="date">${y} 年 ${this.Months[m]} 月</button>
                        <div class='year_selector'>
                       </div>
                    </div>  
                    <button class="btnNext" aria-label="next"><img src="img/icon/chevron-right.svg" class="svg"> </button>
                </div>
            </th>`;
    } else {
      html += `
                <th scope="col" colspan="7"> 
                    <div> 
                        <div class="title right">${y - 1911} 年 ${this.Months[m]} 月</div>
                        <button class="btnNext" aria-label="next"  ${chkY == this.currYear && m == chkM ? "disabled" : ""}><img src="img/icon/chevron-right.svg" class="svg ${chkY == this.currYear && m == chkM ? "disabled" : ""}"> </button>  
                    </div>
                </th>`;
    }
    html += "</tr></thead>";

    // Write the header of the days of the week
    html += '<tr class="days">';
    for (let i = 0; i < this.DaysOfWeek.length; i++) {
      html += `<td>${this.DaysOfWeek[i]}</td>`;
    }
    html += "</tr>";
    // Write the days
    let i = 1;
    do {
      let dow = new Date(y, m, i).getDay();
      // If Sunday, start new row
      if (dow == 0) {
        html += "<tr>";
      }
      // If not Sunday but first day of the month
      // it will write the last days from the previous month
      else if (i == 1) {
        html += "<tr>";
        let k = lastDayOfLastMonth - firstDayOfMonth + 1;
        for (let j = 0; j < firstDayOfMonth; j++) {
          html += `<td class="not-current"><button disabled>${k}</button></td>`;
          k++;
        }
      }

      // Write the current day in the loop
      chkM;
      //
      if (chkY == y && m == chkM && i == this.today) {
        let month = (m + 1).toString().length === 1 ? `0${m + 1}` : m + 1;
        let day = i.toString().length === 1 ? `0${i}` : i;
        let date = `${y}-${month}-${day}`;
        // 選起日（未選起日、已選迄日）時，超出 [迄日往前 N 個月, 迄日] 範圍的「今天」不可選
        let startOutOfRange =
          !start &&
          end &&
          end !== date &&
          (moment(date).isAfter(moment(end)) ||
            (window.calendarMaxRangeMonths && moment(date).isBefore(moment(end).subtract(window.calendarMaxRangeMonths, "months"))));
        if (startOutOfRange) {
          html += `<td class="today disabled"><button disabled>${i}</button></td>`;
        } else if (end) {
          html += `<td class="normal today ${start === date || end === date ? "selected" : ""}" data-date="${date}"><button aria-label="date">${i}</button></td>`;
        } else if (start && !end && window.calendarMaxRangeMonths && moment(date).isAfter(moment(start).add(window.calendarMaxRangeMonths, "months"))) {
          // 選結束日時，超過區間上限的「今天」也不可選
          html += `<td class="today disabled"><button disabled>${i}</button></td>`;
        } else {
          html += `<td class="today" data-date="${date}"><button aria-label="date">${i}</button></td>`;
        }
      } else if (y == chkY && m == chkM && i > this.currDay) {
        // 僅「當年當月」才擋今天之後的未來日期（缺少年份比對會誤擋其他年份的同月日期）
        html += `<td class="disabled"><button disabled>${i}</button></td>`;
      } else {
        let month = (m + 1).toString().length === 1 ? `0${m + 1}` : m + 1;
        let day = i.toString().length === 1 ? `0${i}` : i;
        let date = `${y}-${month}-${day}`;

        if (start && end) {
          let filter_ranged = ranged_obj.filter((d) => d === date);
          html += `<td class="normal ${start === date || end === date ? "selected" : ""} ${filter_ranged.length > 0 ? "ranged" : ""} " data-date="${date}"><button aria-label="date">${i}</button></td>`;
        } else if (start && !end) {
          let after = moment(start).format("X") < moment(date).format("X");
          // 若有設定區間上限（如裁處日期 5 年），超過上限的日期不可選
          let overLimit = window.calendarMaxRangeMonths && moment(date).isAfter(moment(start).add(window.calendarMaxRangeMonths, "months"));
          // 不得選未來（今天之後）的日期
          let afterToday = moment(date).isAfter(moment(), "day");
          let disabledDate = start !== date && (!after || overLimit || afterToday);
          html += `<td class=" ${start === date ? "normal selected" : disabledDate ? "disabled" : "normal"}" data-date="${date}"><button ${disabledDate ? "disabled" : ""} aria-label="date" >${i}</button></td>`;
        } else {
          // 未選起日但已選迄日：起日不得早於「迄日往前 N 個月」，也不得晚於迄日
          let overLimit = end && window.calendarMaxRangeMonths && moment(date).isBefore(moment(end).subtract(window.calendarMaxRangeMonths, "months"));
          let afterEnd = end && moment(date).isAfter(moment(end));
          // 不得選未來（今天之後）的日期
          let afterToday = moment(date).isAfter(moment(), "day");
          let disabledDate = end !== date && (overLimit || afterEnd || afterToday);
          html += `<td class="${disabledDate ? "disabled" : "normal"}" ${disabledDate ? "" : `data-date="${date}"`}><button ${disabledDate ? "disabled" : ""} aria-label="date">${i}</button></td>`;
        }
      }
      // If Saturday, closes the row
      if (dow == 6) {
        html += "</tr>";
      }
      // If not Saturday, but last day of the selected month
      // it will write the next few days from the next month
      else if (i == lastDateOfMonth) {
        let k = 1;
        for (dow; dow < 6; dow++) {
          if (m == chkM) {
            html += `<td class="disabled"><button disabled>${k}</button></td>`;
          } else {
            html += `<td class="not-current"><button disabled>${k}</button></td>`;
          }
          k++;
        }
      }

      i++;
    } while (i <= lastDateOfMonth);

    // Closes table
    html += "</table>";

    // Write HTML to the div
    $(this.divId).empty();
    $(this.divId).append(html);
    svg_to_xml();
    yearSelector(y, y, m);
    $(".header_title").click(function (e) {
      let open = $(this).children(".year_selector").hasClass("open");
      if (open) {
        $(this).children(".year_selector").removeClass("open");
        $(this).children(".year_selector").fadeOut(50);
      } else {
        $(this).children(".year_selector").addClass("open");
        $(this).children(".year_selector").fadeIn(50);
      }
    });
    function monthSelector(selectedYear, activeYear, selectedMonth) {
      let year = selectedYear;
      let Months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
      let Html = `<div class='header'>
            <button class="btnPrev_month" aria-label="prev_month">
            <img src="img/icon/chevron-left.svg" class="svg"> </button>
                <div>${year} 年</div>
                <button class="btnNext_month" aria-label="prev_month"><img src="img/icon/chevron-right.svg" class="svg"> </button>
            </div>
            <div class='body'>`;
      for (let i = 0; i < Months.length; i++) {
        Html += `<button 
                    class='${Months[i] === selectedMonth && activeYear === year ? "active" : ""}' aria-label='month'>${Months[i]}月
                    </button>`;
      }
      Html += `</div>`;
      //    return Html
      $(".year_selector").empty();
      $(".year_selector").append(Html);
      svg_to_xml();

      $(".btnPrev_month").click(function (e) {
        e.stopPropagation();
        let val = parseInt($(this).val());
        // year -= 1
        // y = y - 12
        monthSelector(year - 1, activeYear, selectedMonth);
        svg_to_xml();
      });
      $(".btnNext_month").click(function (e) {
        e.stopPropagation();
        // year += 1
        monthSelector(year + 1, activeYear, selectedMonth);
        svg_to_xml();
      });
      $(".year_selector >.body>button").click(function (e) {
        e.stopPropagation();
        let value = parseInt($(this).text()) - 1;
        c.showMonth(year, value, 0);
        $(".year_selector").fadeOut();
      });
    }
    function yearSelector(y, selectedYear, selectedMonth) {
      let year_arr = [];
      $(".year_selector").empty();
      let year = y;
      for (let i = 0; i < 12; i++) {
        year_arr.unshift(year);
        year -= 1;
      }
      let Html = `<div class='header'>
            <button class="btnPrev_year" aria-label="prev_year">
            <img src="img/icon/chevron-left.svg" class="svg"> </button>
                <div>${year_arr[0]} - ${y}</div>
                <button class="btnNext_year" aria-label="prev_year"><img src="img/icon/chevron-right.svg" class="svg"> </button>
            </div>
            <div class='body'>`;
      for (let i = 0; i < year_arr.length; i++) {
        Html += `<button 
                    class='${year_arr[i] === selectedYear ? "active" : ""}' aria-label='year'>${year_arr[i]}
                    </button>`;
      }
      Html += `</div>`;
      //    return Html
      $(".year_selector").empty();
      $(".year_selector").append(Html);
      svg_to_xml();

      $(".btnPrev_year").click(function (e) {
        e.stopPropagation();
        y = y - 12;
        yearSelector(y, selectedYear);
        svg_to_xml();
      });
      $(".btnNext_year").click(function (e) {
        e.stopPropagation();
        y = y + 12;
        yearSelector(y, selectedYear);
        svg_to_xml();
      });
      $(".year_selector >.body>button").click(function (e) {
        e.stopPropagation();
        let value = parseInt($(this).text());
        monthSelector(value, selectedYear, selectedMonth + 1);
      });
    }
  };
  // Start calendar
  let c = new Cal(".calendar");
  c.showcurr();

  $(".calendar ").delegate("table .btnPrev", "click", function () {
    c.previousMonth();
  });
  $(".calendar ").delegate("table .btnNext", "click", function () {
    c.nextMonth();
  });
  $(".calendar").click((e) => e.stopPropagation());
  $(".close_calendar").click(function (e) {
    e.stopPropagation();
    $(".calendar_icon").removeClass("open");
    $(".calendar").slideUp();
  });
}

$(".calendar_input > input").click(function (e) {
  e.stopPropagation();
  let open = $(this).hasClass("open");
  let value = $(this).val();
  $(".calendar").removeClass("open");
  $(".calendar").slideUp();
  setTimeout(() => {
    if (open) {
      $(this).next(".calendar").removeClass("open");
      $(this).next(".calendar").slideUp();
    } else {
      $(this).next(".calendar").addClass("open");
      $(this).next(".calendar").slideDown();
    }
  }, 100);
  // 點哪個欄位重選，就把該欄位視為「空」來渲染，讓另一欄位觸發 5 年限制反灰
  let editType = $(this).data("type");
  let startArg = editType === "StartDate" ? "" : (fetchData.StartDate || "");
  let endArg = editType === "EndDate" ? "" : (fetchData.EndDate || "");
  customCalendar(startArg, endArg, 0, value);
});
$(".calendar_input > input").keyup(function (e) {
  let value = $(this).val();
  let type = $(this).data("type");
  if (e.keyCode === 13) {
    fetchData[type] = value;
    $(this).next(".calendar").removeClass("open");
    $(this).next(".calendar").slideUp();
  }
});

/**
 * 建立焦點陷阱
 * @param {HTMLElement} element - 要鎖定焦點的容器元件
 * @param {HTMLElement} triggerElement - 當初觸發開啟的按鈕（關閉後焦點要還給它）
 * @param {Function} closeCallback - 按下 Esc 時執行的關閉函式
 */
function createFocusTrap(element, triggerElement, closeCallback) {
  // 1. 定義所有可取得焦點的元素選擇器
  const focusableSelectors = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
  const focusableElements = element.querySelectorAll(focusableSelectors);

  const firstFocusable = focusableElements[0];
  const lastFocusable = focusableElements[focusableElements.length - 1];

  // 2. 開啟時立即將焦點移至第一個元件 (符合 2.4.3 規範)
  if (firstFocusable) firstFocusable.focus();

  // 3. 監聽鍵盤事件
  const handleKeyDown = (e) => {
    const isTab = e.key === "Tab";
    const isEsc = e.key === "Escape";

    // 處理 Esc 關閉 (符合 2.4.7 規範)
    if (isEsc) {
      console.log("menu esc");
      if (closeCallback) closeCallback();
      cleanup();
      return;
    }

    if (!isTab) return;

    if (e.shiftKey) {
      // Shift + Tab 反向循環
      if (document.activeElement === firstFocusable) {
        e.preventDefault();
        lastFocusable.focus();
      }
    } else {
      // Tab 正向循環
      if (document.activeElement === lastFocusable) {
        e.preventDefault();
        firstFocusable.focus();
      }
    }
  };

  // 4. 清除機制：關閉選單時移除監聽並歸還焦點
  function cleanup() {
    element.removeEventListener("keydown", handleKeyDown);
    if (triggerElement) triggerElement.focus();
  }

  element.addEventListener("keydown", handleKeyDown);

  // 回傳清理函式，供外部手動關閉時呼叫
  return cleanup;
}
